/**
 * useTheme Hook
 * Централизованное применение темы: CSS переменные + Google Fonts
 */
import { useEffect } from 'react';
import { getThemeCSS, getThemeFontsUrl, getThemeStyles } from '../lib/themes';

/**
 * Применяет тему к документу
 * @param {string} themeKey - ключ темы (default, warmEarth, forest, etc.)
 * @returns {Object} themeStyles - inline styles с CSS переменными (для SSR/fallback)
 */
export function useTheme(themeKey = 'default') {
  useEffect(() => {
    // 1. Инжектим CSS переменные темы
    const styleId = 'theme-override-styles';
    let styleEl = document.getElementById(styleId);

    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = styleId;
      document.head.appendChild(styleEl);
    }

    styleEl.textContent = getThemeCSS(themeKey);

    // 2. Загружаем Google Fonts для темы
    const fontsUrl = getThemeFontsUrl(themeKey);
    if (fontsUrl) {
      const fontLinkId = 'theme-fonts-link';
      let fontLink = document.getElementById(fontLinkId);

      if (!fontLink) {
        fontLink = document.createElement('link');
        fontLink.id = fontLinkId;
        fontLink.rel = 'stylesheet';
        document.head.appendChild(fontLink);
      }

      fontLink.href = fontsUrl;
    }

    // Cleanup при размонтировании (опционально)
    return () => {
      // Не удаляем стили, т.к. они могут использоваться другими компонентами
    };
  }, [themeKey]);

  // Возвращаем inline styles для обратной совместимости
  return getThemeStyles(themeKey);
}

export default useTheme;
